module.exports = __webpack_public_path__ + "media/openLeftBox.c7900547.mp3";